export default __webpack_public_path__ + "static/quote-video-3-static-81a6317972058ad0a89b8188c23b43a6.png";